import React, { useEffect, useLayoutEffect, useState } from 'react';
import JobListDumb from './JobListDumb';
import queryString from 'query-string';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useUser, useJob } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import { ErrorScreen, Alert, ModalAlert } from 'components/common';
import { CircularProgress, Backdrop } from '@mui/material';
import withRequest from 'hoc/withRequest';
import { ROUTES } from 'consts';

const JobListSmart = (props) => {
  const { parameters, filters, setFilters } = useUser();
  const projects = formatProjectItems(parameters);
  const projectsMap = projects.reduce((a, v) => ({ ...a, [v.value]: v}), {}) ;
  const {
    getContentList,
    contentList,
    contentListStatusMap,
    error,
    success,
    isLoaded,
    postJobAbort,
    postJobAbortAll,
    getJobStatus,
    cleanUpMessage
  } = useJob();
  const [openModal, setOpenModal] = useState(false);
  const history = useHistory();
  const location = useLocation();
  let { search, project=filters.project } = queryString.parse(props.location.search);
  let intervalUpdate;
  /*TODO: Line 96:24:  Assignments to the 'intervalUpdate' variable from inside
   React Hook useEffect will be lost after each render. To preserve the value over
   time, store it in a useRef Hook and keep the mutable value in the '.current'
    property. Otherwise, you can move this variable directly inside useEffect
    react-hooks/exhaustive-deps*/

  const handleListPage = () => {
    if (project !== filters.project) setFilters({ project });
    if (project && !!projectsMap[project]) {
      getContentList({
        query: {
          search,
          projectId: project,
        },
      });
    } else {
      history.push(`?project=${projects[0].value}`)
    };
  };

  const handleSearch = (data) => {
    if (data.project === "#MACRO#"){
      getContentList({
        query: {
          search: data.search.trim(),
          macro: data.project,
        },
      });
    } else {
      const {pathname, search} = location;
      const currentLocation = `${pathname}${search}`;
      let routeToPush = `${ROUTES.JOB_LIST}?project=${data.project}`;
      if (data?.search) routeToPush += `&search=${data.search.trim()}`;

      if (currentLocation === routeToPush) {
        handleListPage();
      } else {
        history.push(routeToPush);
      }
    }

  };

  const handleStopJob = (data) => {
    postJobAbort({
      body: { job_id: data.jobId }
    });
  };

  const handleStopJobAll = () => {
    setOpenModal(false);
    postJobAbortAll({
      body: { project_id: project }
    });
  };

  const handleView = (data) => {
    if (data.templateType !== 'SI' && data.templateType !== 'UP') history.push(`${ROUTES.JOB_RUN_WORKFLOW}/${data.jobId}`);
    else history.push(`${ROUTES.JOB_RUN_TEMPLATE}/${data.jobId}`);
  }

  function updateStatusJobs () {
    const jobId = Object.keys(contentListStatusMap).join(',');
    getJobStatus({ query: {
      jobId
    } });
  }

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, project]);

  useLayoutEffect(() => {
    if (filters.project) handleSearch({ project: filters.project });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (success.postAbort) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.postAbort])

  useEffect(() => {
    if (contentListStatusMap && contentListStatusMap !== {} && success.getContent) {
      intervalUpdate = setInterval(updateStatusJobs, 5000);
    } clearInterval(intervalUpdate);

    return () => clearInterval(intervalUpdate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentListStatusMap]);

  const alerts = [
    {
      severity: 'info',
      open: success.postAbort,
      message: 'jobList.components.alert.successAbort',
    },
    {
      severity: 'warning',
      open: error.postAbort,
      message: 'jobList.components.alert.errorAbort',
    }
  ];

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
        open={isLoaded.postAbort}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      { error.getContent ? (
        <ErrorScreen />
      ) : (
        <JobListDumb
          handleSearch={handleSearch}
          searchValue ={search || ''}
          content={contentList}
          options={projects}
          isLoaded={isLoaded.getContent}
          handleStopJob={handleStopJob}
          handleView={handleView}
          handleStopJobAll={() => setOpenModal(true)}
          defaultValues={{
            search,
            project: !project ? projects[0].value : project,
          }}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={handleStopJobAll}
      />
    </>
  );
};

export default withRequest(withRouter(JobListSmart));
